import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import Authorizer, { FeatureFlags } from '../../components/Authorizer';
import Page from '../../components/Page';
import { Tab, Tabs } from '../../components/TabMenu';
import { getTabSelectOptions } from '../../constants/tabMenuTypes';
import {
  adminPageCompanyCodes,
  adminPageListUsers
} from '../../redux/modules/adminPage';
import { setCurrentPage } from '../../redux/modules/app';
import { getCompanyDepartments } from '../../redux/modules/company';
import { useCompanyCustomRoles } from '../../services/company-service';

const AdminPage = () => {
  const history = useHistory();
  const { companyId } = useParams();
  const dispatch = useDispatch();
  let tabMenuOptions = getTabSelectOptions('adminMenuTabs');
  const companyCustomRoles = useCompanyCustomRoles(companyId, { include: 'permissions' });

  useEffect(() => {
    dispatch(setCurrentPage('admin'));
    dispatch(adminPageListUsers(companyId));
    dispatch(getCompanyDepartments(companyId));
    dispatch(adminPageCompanyCodes(companyId));
  }, [companyId, dispatch]);

  return (
    <Page backgroundColor="grey">
      <Authorizer featureFlag={[FeatureFlags.Codes, FeatureFlags.EmailAutomation, FeatureFlags.CustomRoles]}>
        {({ authorized, authorizedFeatureFlags }) => {
          if (!authorized) return null;

          tabMenuOptions = tabMenuOptions.filter(option => (option?.flag
            ? authorizedFeatureFlags.includes(option.flag)
            : true));

          return (
            <Tabs>
              {tabMenuOptions.map(option => <Tab {...option} key={option.tabId} />)}
            </Tabs>
          );
        }}
      </Authorizer>
    </Page>
  );
};

export default AdminPage;
